"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContainer = void 0;
const theme_1 = require("@icr-ui/theme");
const styled_components_1 = __importStar(require("styled-components"));
exports.StyledContainer = (0, styled_components_1.default)('div')(({ withGap, fluid, theme, customStyles }) => {
    var _a, _b, _c, _d, _e, _f;
    const d = (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.gridDefaults) === null || _a === void 0 ? void 0 : _a.breakpoints) !== null && _b !== void 0 ? _b : theme_1.defaultGrid.breakpoints;
    const p = (_d = (_c = theme === null || theme === void 0 ? void 0 : theme.gridDefaults) === null || _c === void 0 ? void 0 : _c.paddings) !== null && _d !== void 0 ? _d : theme_1.defaultGrid.paddings;
    const m = (_f = (_e = theme === null || theme === void 0 ? void 0 : theme.gridDefaults) === null || _e === void 0 ? void 0 : _e.margins) !== null && _f !== void 0 ? _f : theme_1.defaultGrid.margins;
    const defaultWidth = (size) => {
        if (!size) {
            return '100%';
        }
        return `calc(100vw - ${m[size] * 2}px)`;
    };
    return (0, styled_components_1.css) `
      display: flex;
      flex-direction: column;
      margin: 0 auto;

      @media (min-width: ${`${d.xs}px`}) and (max-width: ${`${d.sm}px`}) {
        padding: 0;

        max-width: ${fluid ? defaultWidth() : `${d.sm}px`};
      }

      @media (min-width: ${`${d.sm + 1}px`}) and (max-width: ${`${d.md}px`}) {
        padding: 0;

        max-width: ${fluid ? defaultWidth() : `${d.md}px`};
      }

      @media (min-width: ${`${d.md + 1}px`}) and (max-width: ${`${d.lg}px`}) {
        padding: 0;

        max-width: ${fluid ? defaultWidth() : `${d.lg}px`};
      }

      @media (min-width: ${`${d.lg}px`}) {
        padding: 0;

        max-width: ${fluid ? defaultWidth() : `${d.xl - 1}px`};
      }
      ${withGap &&
        (0, styled_components_1.css) `
        gap: 40px;
        @media (max-width: ${`${theme_1.grid.vpBreakpoints.VPS}px`}) {
          gap: 32px;
        }
      `}
      ${customStyles !== null && customStyles !== void 0 ? customStyles : {}}
    `;
});
//# sourceMappingURL=styles.js.map